export default "__VITE_ASSET__a42fee1c__"